import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api/api.service';
import {ErrorMessageService} from '../../../services/error-message/error-message.service';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';
import {StorageMap} from '@ngx-pwa/local-storage';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SignupComponent } from '../signup/signup.component';
import { CreateEventComponent } from '../create-event/create-event.component';
import { NgIf } from '@angular/common';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-demo-onboarding',
    templateUrl: './demo-onboarding.component.html',
    styleUrls: ['./demo-onboarding.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, NgIf, CreateEventComponent, SignupComponent, FontAwesomeModule, RouterLink]
})
export class DemoOnboardingComponent implements OnInit {
  constructor(private api: ApiService,
              private errMsgSvc: ErrorMessageService,
              private googleAnalyticsService: GoogleAnalyticsService,
              private storage: StorageMap) {
  }

  public eventNameExists = false;
  public eventCreated = false;
  public eventName = '';
  public error = '';
  public busy = false;

  public eventNameSubmitted(eventName: string): void {
    this.eventNameExists = true;
    this.eventName = eventName;
    this.googleAnalyticsService.sendEvent('sign_up_set_event_name');
  }

  public ngOnInit(): void {
    this.googleAnalyticsService.sendEvent('sign_up_start');
  }

  public accountDetailsSubmitted(accountDetails: {
    firstName: string,
    lastName: string,
    emailAddress: string,
    password: string,
  }): Promise<void> {
    this.busy = true;
    return this.api.demoSignup(accountDetails).then(token => {
      this.storage.get('referrer').subscribe(ref => {
        this.api.addFirstEvent(this.eventName, token, <string>ref).then(() => {
          this.eventCreated = true;
        }, error => {
          this.error = this.errMsgSvc.generate(error, {
            422: 'Dit emailadres is al in gebruik onder een ander account.',
            401: 'Je hebt op dit moment niet de rechten om een account aan te maken. Neem contact op met het BijB-team via het kopje contact ' +
              'als je dit wil oplossen.'
          });
        }).then(() => {
          this.googleAnalyticsService.sendEvent('sign_up');
          this.busy = false;
        });
      });
    }, error => {
      this.error = this.errMsgSvc.generate(error, {
        422: 'Dit emailadres is al in gebruik onder een ander account.',
        401: 'Je hebt op dit moment niet de rechten om een account aan te maken. Neem contact op met het BijB-team via het kopje contact ' +
          'als je dit wil oplossen.'
      });
      this.busy = false;
    });
  }
}
